import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=11705616&scoped=true&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&id=11705616&prod&lang=less&"
import style1 from "./menu.vue?vue&type=style&index=1&id=11705616&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11705616",
  null
  
)

export default component.exports